import { inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { AppTranslationService } from '../../core/translation.service';

@Injectable()
export class AppMatPaginatorIntl extends MatPaginatorIntl {
  private readonly appTranslationService: AppTranslationService = inject(AppTranslationService);

  override itemsPerPageLabel = 'Rows per page:';

  constructor() {
    super();
    this.appTranslationService.translateAsync('common.paginator.paginationPrevious').subscribe((res) => {
      this.previousPageLabel = res;
    });
    this.appTranslationService.translateAsync('common.paginator.paginationNext').subscribe((res) => {
      this.nextPageLabel = res;
    });
  }
}
